export default {
  // Company

  name: "Name",
  company: "Firma",
  uidNumber: "UID / Steuer Nr.",
  uidNumberShort: "UID",
  taxIdNumberFull: "UID / Steuernummer",
  licenceModel: "Lizenzmodell",

  // User definition

  salutation: "Anrede",
  salutationPlural: "Anreden",
  letterSalutation: "Briefanrede",
  academicTitle: "Titel",
  firstName: "Vorname",
  lastName: "Nachname",
  street: "Straße",
  streetNumber: "Hausnummer",
  zipCode: "PLZ",
  city: "Ort",
  country: "Land",
  phoneNumber: "Telefon",
  dateOfBirth: "Geburtsdatum",

  // User authentication

  user: "Benutzer",
  account: "Konto",
  unknown: "Unbekannt",
  email: "E-Mail",
  username: "Benutzername",
  operator: "Bediener",
  operatorCode: "Bediener-Code",
  password: "Passwort",
  repeatPassword: "Passwort bestätigen",
  login: "Login",
  logout: "Logout",
  loggedInAs: "angemeldet als",
  action: "Aktivität",

  // Descriptive

  none: "Keine",
  color: "Farbe",
  preview: "Vorschau",
  label: "Bezeichnung",
  standard: "Standard",
  assignment: "Zuordnung",
  description: "Beschreibung",
  additionalText: "Bemerkung",
  properties: "Eigenschaften",

  // State declaration

  note: "Hinweis",
  error: "Fehler",
  status: "Status",
  warning: "Warnung",
  active: "Aktiv",

  // Contact / Client

  client: "Kunde",
  clients: "Kunden",
  departments: "Abteilungen",
  personsInCharge: "Ansprechpartner",
  shippingAddress: "Lieferadresse",
  shippingAddresses: "Lieferadressen",
  landLinePhoneNumber: "Festnetz",
  landLinePhoneNumberPlaceholder: "+43 3141 1234",
  customerSignature: "Kunden-Unterschrift",

  // Receipt

  receipts: "Belege",
  number: "Nummer",
  output: "Ausgabe",
  receiptNumber: "Belegnummer",
  roundingDifference: "Rundungsdifferenz",
  discount: "Rabatt",
  cartDiscount: "Warenkorbrabatt",
  value: "Betrag",
  article: "Artikel",
  taxGroup: "Steuergruppe",
  articleNumber: "Artikelnummer",
  mainGroup: "Hauptgruppe",
  mainGroups: "Hauptgruppen",
  articleGroup: "Warengruppe",
  articleGroups: "Warengruppen",
  amount: "Menge",
  sum: "Summe",
  net: "Netto",
  gross: "Brutto",
  tax: "Steuer",
  turnover: "Umsatz",
  default: "Standard",
  rksv: "RKSV",
  total: "Gesamt",
  price: "Preis",
  aTrustAccount: "A-Trust-Account",
  copy: "KOPIE",
  receiptCopy: "BELEGKOPIE",
  pricePerUnit: "EZP",
  tip: "Trinkgeld",

  // Cash flow receipt

  cashFlow: "Geldbewegung",
  disbursal: "Auszahlung",
  deposit: "Einzahlung",
  deposits: "Einzahlungen",
  disbursals: "Auszahlungen",

  // Filter / Search / Temporal

  date: "Datum",
  datetime: "Datum / Uhrzeit",
  from: "Von",
  to: "Bis",
  today: "Heute",
  now: "Jetzt",
  all: "Alle",
  search: "Suche",
  filter: "Filter",
  past: "Vergangenheit",
  future: "Zukunft",
  touchToEnter: "Tippen zur Eingabe",
  selectDate: "Wählen Sie ein Datum aus...",
  searchPlaceholder: "Bitte geben Sie einen Suchbegriff ein.",
  countrySelectionTitle: "Wählen Sie ein Land aus...",
  chooseASalutation: "Wählen Sie eine Anrede aus...",
  origin: "Herkunft",
  cashRegister: "Kasse",
  cashRegisters: "Kassen",
  paymentMethod: "Zahlungsart",
  paymentMethods: "Zahlungsarten",
  voucher: "Gutschein",
  cash: "Bar",

  // Button labels

  send: "Senden",
  done: "Fertig",
  confirm: "Bestätigen",
  understood: "Verstanden",
  save: "Speichern",
  cancel: "Abbrechen",
  close: "Schließen",
  delete: "Löschen",
  remove: "Entfernen",
  reset: "Zurücksetzen",
  exchange: "Wechseln",
  newItem: "Neu anlegen",
  printPreview: "Druckansicht",
  download: "Download",
  pdfDownload: "PDF-Download",
  csvDownload: "CSV-Download",
  sendByMail: "Per E-Mail",
  export: "Export",
  exportDialogTitle: "Exportoption auswählen",
  exportDialogStandard: "Standard Export",
  exportDialogDetailed: "Detaillierter Export",
  isDefault: "Als Standard verwenden",
  showMore: "Mehr anzeigen",
  showLess: "Weniger anzeigen",
  proceed: "Fortfahren",

  // Others

  help: "Hilfe",
  editX: "{{name}} bearbeiten",
  additionalTextMaxCharacters: "max. 30 Zeichen möglich",

  emptyOptionMessage: "Keine Optionen vorhanden.",
  noSelectionItemsFound: "Für diese Auswahl sind keine Einträge vorhanden.",
  noSelectionItemsForSearch:
    "Für diesen Suchbegriff wurden keine Einträge gefunden.",
  possibleReasonsTooltip: "Mögliche Ursachen",
  functionNotAvailableHint: "Warum ist diese Funktion deaktiviert?",

  errorGeneric:
    "Ein unerwarteter Fehler ist aufgetreten. Bitte kontaktieren Sie den Support.",
  errorDuplicateCommand:
    "Diese Aktion wurde bereits durchgeführt. Bitte überprüfen Sie, " +
    "ob diese zur gewünschten Reaktion geführt hat.",
  errorUserLoggedOut: "Ihre Sitzung ist abgelaufen. Sie wurden ausgeloggt.",
  errorConnectionLost:
    "Verbindung konnte nicht hergestellt werden. Bitte prüfen Sie Ihre Internetverbindung.",

  loadingIndicatorFallback: "Ladevorgang...",
  genericErrorFallback: "Allgemeiner Fehler",
  genericErrorFallbackTitle: "Ein Fehler ist aufgetreten.",
  genericErrorFallbackMessage:
    "Überprüfen Sie Ihre Aktion und " +
    "versuchen Sie diese gegebenenfalls zu einem späteren Zeitpunkt erneut.\n" +
    "Sollte dieser Fehler erneut auftreten, bitten wir Sie, " +
    "diese Ansicht geöffnet zu lassen und den Support zu kontaktieren.",
  timeoutErrorFallback: "Zeitüberschreitung",
  timeoutErrorFallbackMessage: "Die Anfrage an den Server ist fehlgeschlagen.",
  networkErrorFallback: "Verbindungsprobleme",
  networkErrorFallbackUnknownMessage: "Netzwerkfehler",
  networkErrorFallbackNoInternetMessage: "Keine Internetverbindung vorhanden.",
  tryAgainLabel: "Erneut versuchen",
} as const
